import { $, $$ } from '../helpers/selectors';

class Floodlight {
  constructor() {
    //Analytics Tracking for Showcase Module
    if ($('.js-showcase-floodlight')) {
      $$('.js-showcase-floodlight').forEach(sCta => {
        sCta.addEventListener('click', e => {
          e.preventDefault();
          const href = e.target.getAttribute('href');
          //Add a little delay to proerly send the pixel
          setTimeout(() => {
            window.location = href;
          }, 200);
        });
      });
    }

    //Analytics Tracking for Program Table card links
    if ($('.table-card__link')) {
      $$('.table-card__link').forEach(tLink => {
        tLink.addEventListener('click', e => {
          e.stopPropagation();
          const programTitle = e.currentTarget.getAttribute('data-title');
          window.dataLayer.push({
            event: 'recirculation',
            eventType: 'program grid cell click',
            programTitle,
          });
        });
      });
    }

    //Analytics Tracking for Profile Page
    if ($('.profile-page')) {
      $$('.profile-page .sidebar-menu a').forEach(link => {
        link.addEventListener('click', e => {
          window.dataLayer.push({
            event: 'profile',
            eventType: 'tab click',
            eventLabel: e.currentTarget.text.trim(),
          });
        });
      });
    }
  }
}

export default Floodlight;
